import _ from "lodash/lodash";
import Moment from "moment";
import {UUID} from "./calendar.model";

export default class CalendarData {

    constructor(data) {
        this.id = UUID();
        this._date = null;
        this.title = null;
        this.items = [];
        this.options = {};
        this.timeUnit = 'day';

        this.isCurrentHour = false;
        this.isCurrentDay = false;
        this.isCurrentWeek = false;
        this.isCurrentMonth = false;

        if (data) {
            Object.assign(this, data);
        }
    }

    get date() {
        return this._date;
    }

    set date(date) {
        this._date = Moment(date);

        if (date) {
            var currentDate = Moment();
            this.isCurrentHour = currentDate.hour() == this.date.hour();
            this.isCurrentDay = currentDate.isSame(this.date, 'day');
            this.isCurrentWeek = currentDate.isSame(this.date, 'week');
            this.isCurrentMonth = currentDate.isSame(this.date, 'month');
        } else {
            this.isCurrentHour = false;
            this.isCurrentDay = false;
            this.isCurrentWeek = false;
            this.isCurrentMonth = false;
        }
    }

    add(item) {
        this.items.push(item);
    }

    remove(item) {
        _(this.items).remove(_item => _item.id == item.id);
    }

    clearItems() {
        this.items = [];
    }

    currentHourOffset() {
        return Moment().minutes();
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/calendar-data.model.js